import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-amber text-wood-dark hover:bg-amber-dark shadow-warm hover:shadow-warm-lg hover:-translate-y-1 focus:ring-amber',
    outline: 'border-2 border-wood-medium text-wood-dark hover:bg-wood-medium hover:text-cream focus:ring-wood-medium',
    ghost: 'text-wood-dark hover:bg-wood-medium/10 focus:ring-wood-medium'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  const content = <>
      {children}
      {variant === 'primary' && <ChevronRight className="ml-2 w-6 h-6" data-id="element-342" />}
    </>;
  if (href) {
    return <a href={href} className={classes} data-id="element-343">
        {content}
      </a>;
  }
  return <motion.button whileTap={{
    scale: 0.98
  }} className={classes} {...props} data-id="element-344">
      {content}
    </motion.button>;
}